// Mock data for Integrations & Data Connectors

export const erpIntegrations = [
  {
    id: 1,
    name: 'SAP ERP',
    category: 'ERP/Procurement',
    status: 'Connected',
    region: 'Saudi Arabia',
    vendor: 'SAP SE',
    dataTypes: ['Purchase Orders', 'Budgets', 'Approvals', 'Media Plans', 'Cost Centers'],
    lastSync: '2025-01-15T10:30:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 15420,
    healthScore: 98,
    configuration: {
      endpoint: 'https://sap-mena.company.com/api',
      authentication: 'OAuth 2.0',
      modules: ['MM', 'FI', 'CO']
    }
  },
  {
    id: 2,
    name: 'Oracle Procurement Cloud',
    category: 'ERP/Procurement',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Oracle Corporation',
    dataTypes: ['Procurement Requests', 'Supplier Data', 'Contract Management', 'Spend Analytics'],
    lastSync: '2025-01-15T09:45:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 8930,
    healthScore: 95,
    configuration: {
      endpoint: 'https://oracle-uae.company.com/fscmRestApi',
      authentication: 'Basic Auth',
      modules: ['Procurement', 'Supplier Portal']
    }
  },
  {
    id: 3,
    name: 'NetSuite ERP',
    category: 'ERP/Procurement',
    status: 'Pending Setup',
    region: 'Egypt',
    vendor: 'NetSuite Inc.',
    dataTypes: ['Financial Data', 'Vendor Management', 'Purchase Orders', 'Budget Planning'],
    lastSync: null,
    syncFrequency: 'Daily',
    recordsCount: 0,
    healthScore: 0,
    configuration: {
      endpoint: 'https://netsuite-egypt.company.com/app',
      authentication: 'Token Based',
      modules: ['Procurement', 'Financials']
    }
  }
];

export const invoiceIntegrations = [
  {
    id: 4,
    name: 'ZATCA E-Invoice',
    category: 'Invoice System',
    status: 'Connected',
    region: 'Saudi Arabia',
    vendor: 'Saudi ZATCA',
    dataTypes: ['E-Invoices', 'Tax Compliance', 'Payment Records', 'Vendor Payments'],
    lastSync: '2025-01-15T11:15:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 3250,
    healthScore: 100,
    configuration: {
      endpoint: 'https://zatca.gov.sa/api',
      authentication: 'Digital Certificate',
      compliance: 'Phase 2 Compliant'
    }
  },
  {
    id: 5,
    name: 'VAT Invoice System',
    category: 'Invoice System',
    status: 'Connected',
    region: 'UAE',
    vendor: 'UAE FTA',
    dataTypes: ['VAT Invoices', 'Payment Records', 'Tax Returns', 'Vendor Invoices'],
    lastSync: '2025-01-15T10:20:00Z',
    syncFrequency: 'Daily',
    recordsCount: 2180,
    healthScore: 92,
    configuration: {
      endpoint: 'https://uae-fta.gov.ae/api',
      authentication: 'API Key',
      compliance: 'VAT Compliant'
    }
  },
  {
    id: 6,
    name: 'Odoo Invoice Management',
    category: 'Invoice System',
    status: 'Connected',
    region: 'Morocco',
    vendor: 'Odoo S.A.',
    dataTypes: ['Vendor Invoices', 'Payment Tracking', 'Expense Management', 'Approval Workflows'],
    lastSync: '2025-01-15T08:30:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 1890,
    healthScore: 88,
    configuration: {
      endpoint: 'https://odoo-morocco.company.com/api',
      authentication: 'Session Token',
      modules: ['Accounting', 'Purchase']
    }
  }
];

export const crmIntegrations = [
  {
    id: 7,
    name: 'Salesforce MENA',
    category: 'CRM/Sales Data',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Salesforce.com',
    dataTypes: ['Customer Data', 'Sales Pipeline', 'Attribution Data', 'Lead Sources', 'Campaign Performance'],
    lastSync: '2025-01-15T11:00:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 45600,
    healthScore: 96,
    configuration: {
      endpoint: 'https://mena.salesforce.com/services/data',
      authentication: 'OAuth 2.0',
      objects: ['Account', 'Opportunity', 'Campaign', 'Lead']
    }
  },
  {
    id: 8,
    name: 'HubSpot Marketing Hub',
    category: 'CRM/Sales Data',
    status: 'Connected',
    region: 'Saudi Arabia',
    vendor: 'HubSpot Inc.',
    dataTypes: ['Marketing Attribution', 'Customer Journey', 'Lead Scoring', 'Campaign ROI'],
    lastSync: '2025-01-15T10:45:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 28400,
    healthScore: 94,
    configuration: {
      endpoint: 'https://api.hubspot.com/crm/v3',
      authentication: 'Private App Token',
      portals: ['Marketing', 'Sales', 'Service']
    }
  },
  {
    id: 9,
    name: 'Microsoft Dynamics 365',
    category: 'CRM/Sales Data',
    status: 'Error',
    region: 'Egypt',
    vendor: 'Microsoft Corporation',
    dataTypes: ['Sales Data', 'Customer Insights', 'Marketing Automation', 'Attribution Models'],
    lastSync: '2025-01-14T15:20:00Z',
    syncFrequency: 'Daily',
    recordsCount: 12300,
    healthScore: 45,
    configuration: {
      endpoint: 'https://dynamics-egypt.company.com/api/data',
      authentication: 'Azure AD',
      entities: ['Account', 'Contact', 'Opportunity']
    }
  }
];

export const additionalIntegrations = [
  // Sales & Retail Integrations
  {
    id: 19,
    name: 'Retail POS Systems',
    category: 'Sales Data',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Multiple POS Vendors',
    dataTypes: ['Point of Sale Data', 'Transaction Records', 'Product Performance', 'Store Analytics'],
    lastSync: '2025-01-15T11:45:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 156000,
    healthScore: 94,
    configuration: {
      endpoints: ['Majid Al Futtaim', 'Carrefour', 'LuLu Group'],
      authentication: 'API Keys',
      dataFormat: 'JSON/XML'
    }
  },
  {
    id: 20,
    name: 'E-commerce Analytics',
    category: 'Sales Data',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'Shopify/WooCommerce',
    dataTypes: ['Online Sales', 'Customer Journey', 'Cart Analytics', 'Conversion Funnel'],
    lastSync: '2025-01-15T11:40:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 89000,
    healthScore: 91,
    configuration: {
      platforms: ['Shopify', 'WooCommerce', 'Magento'],
      authentication: 'OAuth 2.0',
      webhooks: 'Enabled'
    }
  },
  // Enhanced Media Channel Integrations
  {
    id: 21,
    name: 'LinkedIn Ads MENA',
    category: 'Media Channel',
    channel: 'Digital',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'LinkedIn Corporation',
    dataTypes: ['B2B Campaign Data', 'Professional Demographics', 'Lead Generation', 'Engagement Metrics'],
    lastSync: '2025-01-15T11:35:00Z',
    syncFrequency: 'Daily',
    recordsCount: 23400,
    healthScore: 89,
    configuration: {
      endpoint: 'https://api.linkedin.com/rest/adAccounts',
      authentication: 'OAuth 2.0',
      accounts: ['linkedin-mena-001', 'linkedin-gcc-002']
    }
  },
  {
    id: 22,
    name: 'TikTok for Business',
    category: 'Media Channel',
    channel: 'Digital',
    status: 'Pending Setup',
    region: 'Saudi Arabia',
    vendor: 'ByteDance Ltd.',
    dataTypes: ['Video Ad Performance', 'Viral Metrics', 'Gen Z Analytics', 'Creative Insights'],
    lastSync: null,
    syncFrequency: 'Real-time',
    recordsCount: 0,
    healthScore: 0,
    configuration: {
      endpoint: 'https://business-api.tiktok.com/open_api',
      authentication: 'Access Token',
      sandbox: 'Enabled'
    }
  },
  // Footfall & Traffic Data
  {
    id: 23,
    name: 'Etisalat Mobility Data',
    category: 'Footfall Analytics',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Etisalat Group',
    dataTypes: ['Mobility Patterns', 'Foot Traffic', 'Demographic Movement', 'Location Analytics'],
    lastSync: '2025-01-15T10:30:00Z',
    syncFrequency: 'Daily',
    recordsCount: 445000,
    healthScore: 87,
    configuration: {
      endpoint: 'https://mobility.etisalat.ae/api',
      authentication: 'Enterprise License',
      privacy: 'GDPR Compliant'
    }
  },
  {
    id: 24,
    name: 'STC Mobility Intelligence',
    category: 'Footfall Analytics',
    status: 'Connected',
    region: 'Saudi Arabia',
    vendor: 'Saudi Telecom Company',
    dataTypes: ['Population Density', 'Traffic Patterns', 'Event Correlation', 'Regional Insights'],
    lastSync: '2025-01-15T10:00:00Z',
    syncFrequency: 'Daily',
    recordsCount: 678000,
    healthScore: 93,
    configuration: {
      endpoint: 'https://data.stc.com.sa/mobility',
      authentication: 'API License',
      regions: ['Riyadh', 'Jeddah', 'Dammam']
    }
  },
  // Benchmarking & Competitive Intelligence
  {
    id: 25,
    name: 'Nielsen AdEx MENA',
    category: 'Benchmarks',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'Nielsen Holdings',
    dataTypes: ['Ad Spend Benchmarks', 'Industry Rates', 'Competitive Analysis', 'Market Share Data'],
    lastSync: '2025-01-15T08:00:00Z',
    syncFrequency: 'Weekly',
    recordsCount: 12400,
    healthScore: 96,
    configuration: {
      endpoint: 'https://adex.nielsen.com/mena/api',
      authentication: 'Subscription License',
      coverage: '13 MENA countries'
    }
  },
  {
    id: 26,
    name: 'Kantar Media Intelligence',
    category: 'Benchmarks',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'Kantar Group',
    dataTypes: ['Media Monitoring', 'Brand Tracking', 'Audience Measurement', 'Campaign Effectiveness'],
    lastSync: '2025-01-15T07:30:00Z',
    syncFrequency: 'Daily',
    recordsCount: 89000,
    healthScore: 92,
    configuration: {
      endpoint: 'https://intelligence.kantar.com/api',
      authentication: 'Premium License',
      modules: ['Media', 'Brands', 'Audiences']
    }
  },
  {
    id: 27,
    name: 'Comscore Digital Analytics',
    category: 'Benchmarks',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Comscore Inc.',
    dataTypes: ['Digital Audience Data', 'Cross-Platform Measurement', 'Programmatic Insights', 'Video Analytics'],
    lastSync: '2025-01-15T09:15:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 156000,
    healthScore: 88,
    configuration: {
      endpoint: 'https://api.comscore.com/v1',
      authentication: 'Client Credentials',
      markets: ['UAE', 'Saudi Arabia', 'Kuwait']
    }
  },
  // Traffic & GPS Data
  {
    id: 28,
    name: 'HERE Traffic Analytics',
    category: 'Traffic Maps',
    status: 'Active',
    region: 'All Regions',
    vendor: 'HERE Technologies',
    dataTypes: ['Real-time Traffic', 'Route Analytics', 'Location Intelligence', 'Mobility Insights'],
    lastSync: '2025-01-15T11:50:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 892000,
    healthScore: 95,
    configuration: {
      endpoint: 'https://traffic.api.here.com/v8',
      authentication: 'API Key',
      coverage: 'MENA Region'
    }
  }
];

export const mediaChannelIntegrations = [
  {
    id: 10,
    name: 'Google Ads API',
    category: 'Media Channel',
    channel: 'Digital',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'Google MENA',
    dataTypes: ['Campaign Performance', 'Spend Data', 'Impressions', 'Clicks', 'Conversions'],
    lastSync: '2025-01-15T11:30:00Z',
    syncFrequency: 'Hourly',
    recordsCount: 89200,
    healthScore: 99,
    configuration: {
      endpoint: 'https://googleads.googleapis.com/v15',
      authentication: 'OAuth 2.0',
      accounts: ['MENA-123456789', 'MENA-987654321']
    }
  },
  {
    id: 11,
    name: 'Meta Business API',
    category: 'Media Channel',
    channel: 'Digital',
    status: 'Connected',
    region: 'All Regions',
    vendor: 'Meta MENA',
    dataTypes: ['Campaign Metrics', 'Ad Spend', 'Reach', 'Engagement', 'Attribution'],
    lastSync: '2025-01-15T11:25:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 67800,
    healthScore: 97,
    configuration: {
      endpoint: 'https://graph.facebook.com/v18.0',
      authentication: 'Access Token',
      accounts: ['act_123456789', 'act_987654321']
    }
  },
  {
    id: 12,
    name: 'Snapchat Ads API',
    category: 'Media Channel',
    channel: 'Digital',
    status: 'Connected',
    region: 'Saudi Arabia',
    vendor: 'Snap Inc.',
    dataTypes: ['Campaign Data', 'Audience Insights', 'Creative Performance', 'Swipe Rates'],
    lastSync: '2025-01-15T10:15:00Z',
    syncFrequency: 'Daily',
    recordsCount: 15600,
    healthScore: 91,
    configuration: {
      endpoint: 'https://adsapi.snapchat.com/v1',
      authentication: 'OAuth 2.0',
      accounts: ['snap-ksa-001', 'snap-ksa-002']
    }
  },
  {
    id: 13,
    name: 'MBC Group TV Data',
    category: 'Media Channel',
    channel: 'TV',
    status: 'Connected',
    region: 'UAE',
    vendor: 'MBC Group',
    dataTypes: ['Viewership Data', 'Ad Placement', 'Audience Demographics', 'Reach & Frequency'],
    lastSync: '2025-01-15T09:00:00Z',
    syncFrequency: 'Daily',
    recordsCount: 5420,
    healthScore: 85,
    configuration: {
      endpoint: 'https://mbc-data.company.com/api',
      authentication: 'API Key',
      channels: ['MBC1', 'MBC2', 'MBC3', 'MBC4']
    }
  },
  {
    id: 14,
    name: 'Al Khaleej Print Analytics',
    category: 'Media Channel',
    channel: 'Print',
    status: 'Connected',
    region: 'UAE',
    vendor: 'Al Khaleej Newspapers',
    dataTypes: ['Circulation Data', 'Ad Placement', 'Readership Analytics', 'Geographic Distribution'],
    lastSync: '2025-01-15T07:30:00Z',
    syncFrequency: 'Weekly',
    recordsCount: 1250,
    healthScore: 78,
    configuration: {
      endpoint: 'https://alkhaleej-analytics.com/api',
      authentication: 'Basic Auth',
      publications: ['Al Khaleej', 'Weekend Edition']
    }
  },
  {
    id: 15,
    name: 'Clear Channel Outdoor',
    category: 'Media Channel',
    channel: 'Outdoor',
    status: 'Pending Setup',
    region: 'Qatar',
    vendor: 'Clear Channel MENA',
    dataTypes: ['Billboard Performance', 'Footfall Data', 'Digital Display Metrics', 'Location Analytics'],
    lastSync: null,
    syncFrequency: 'Daily',
    recordsCount: 0,
    healthScore: 0,
    configuration: {
      endpoint: 'https://clearchannel-qatar.com/api',
      authentication: 'JWT Token',
      locations: ['Doha CBD', 'Airport Road', 'Corniche']
    }
  }
];

export const regionalCalendars = [
  {
    region: 'Saudi Arabia',
    events: [
      { name: 'Saudi National Day', date: '2025-09-23', type: 'National Holiday', impact: 'High' },
      { name: 'Ramadan', date: '2025-03-01', duration: 30, type: 'Religious', impact: 'Very High' },
      { name: 'Saudi Vision 2030 Summit', date: '2025-04-15', type: 'Business Event', impact: 'Medium' },
      { name: 'Riyadh Season', date: '2025-10-01', duration: 120, type: 'Entertainment', impact: 'High' },
      { name: 'Black Friday', date: '2025-11-29', type: 'Shopping Event', impact: 'Very High' }
    ]
  },
  {
    region: 'UAE',
    events: [
      { name: 'UAE National Day', date: '2025-12-02', type: 'National Holiday', impact: 'High' },
      { name: 'Dubai Shopping Festival', date: '2025-01-01', duration: 60, type: 'Shopping Event', impact: 'Very High' },
      { name: 'Ramadan', date: '2025-03-01', duration: 30, type: 'Religious', impact: 'Very High' },
      { name: 'Expo Follow-up Events', date: '2025-05-15', type: 'Business Event', impact: 'Medium' },
      { name: 'Summer Surprise', date: '2025-06-15', duration: 45, type: 'Shopping Event', impact: 'High' }
    ]
  },
  {
    region: 'Egypt',
    events: [
      { name: 'Revolution Day', date: '2025-07-23', type: 'National Holiday', impact: 'High' },
      { name: 'Ramadan', date: '2025-03-01', duration: 30, type: 'Religious', impact: 'Very High' },
      { name: 'Cairo International Film Festival', date: '2025-11-20', duration: 10, type: 'Cultural Event', impact: 'Medium' },
      { name: 'Back to School Season', date: '2025-09-01', duration: 30, type: 'Educational', impact: 'High' }
    ]
  },
  {
    region: 'Qatar',
    events: [
      { name: 'Qatar National Day', date: '2025-12-18', type: 'National Holiday', impact: 'High' },
      { name: 'Ramadan', date: '2025-03-01', duration: 30, type: 'Religious', impact: 'Very High' },
      { name: 'Doha Jewelry & Watches Exhibition', date: '2025-02-15', duration: 5, type: 'Trade Event', impact: 'Medium' },
      { name: 'Qatar Summer Festival', date: '2025-07-01', duration: 60, type: 'Entertainment', impact: 'High' }
    ]
  }
];

export const apiConnectors = [
  {
    id: 16,
    name: 'REST API Gateway',
    category: 'Data Connector',
    status: 'Active',
    region: 'All Regions',
    vendor: 'MediaOps Internal',
    dataTypes: ['API Endpoints', 'Request Routing', 'Authentication', 'Rate Limiting'],
    lastSync: '2025-01-15T11:30:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 125000,
    healthScore: 99,
    type: 'Generic REST',
    endpoints: 45,
    requestsPerDay: 125000,
    uptime: 99.8,
    configuration: {
      baseUrl: 'https://api.mediaops.company.com',
      authentication: 'Multiple (OAuth, API Key, JWT)',
      rateLimit: '1000 requests/minute'
    }
  },
  {
    id: 17,
    name: 'GraphQL Unified API',
    category: 'Data Connector',
    status: 'Active',
    region: 'All Regions',
    vendor: 'MediaOps Internal',
    dataTypes: ['Unified Schema', 'Query Optimization', 'Real-time Subscriptions', 'Data Federation'],
    lastSync: '2025-01-15T11:25:00Z',
    syncFrequency: 'Real-time',
    recordsCount: 89000,
    healthScore: 99,
    type: 'GraphQL',
    endpoints: 1,
    requestsPerDay: 89000,
    uptime: 99.9,
    configuration: {
      endpoint: 'https://graphql.mediaops.company.com',
      authentication: 'JWT Bearer Token',
      schema: 'Unified Media Schema v2.1'
    }
  },
  {
    id: 18,
    name: 'Webhook Manager',
    category: 'Data Connector',
    status: 'Active',
    region: 'All Regions',
    vendor: 'MediaOps Internal',
    dataTypes: ['Event Notifications', 'Real-time Updates', 'Delivery Confirmation', 'Retry Management'],
    lastSync: '2025-01-15T11:20:00Z',
    syncFrequency: 'Event-driven',
    recordsCount: 67000,
    healthScore: 97,
    type: 'Webhooks',
    endpoints: 23,
    requestsPerDay: 67000,
    uptime: 99.7,
    configuration: {
      webhookUrl: 'https://webhooks.mediaops.company.com',
      retryPolicy: '3 attempts with exponential backoff',
      security: 'HMAC-SHA256 signatures'
    }
  }
];

export const integrationCategories = [
  'All Categories',
  'ERP/Procurement', 
  'Invoice System',
  'CRM/Sales Data',
  'Media Channel',
  'Sales Data',
  'Footfall Analytics',
  'Benchmarks',
  'Traffic Maps',
  'Data Connector'
];

export const integrationStatuses = [
  'All Status',
  'Connected',
  'Pending Setup',
  'Error',
  'Disconnected',
  'Active'
];

export const integrationRegions = [
  'All Regions',
  'Saudi Arabia',
  'UAE',
  'Egypt',
  'Qatar',
  'Kuwait',
  'Iraq',
  'Morocco',
  'Jordan',
  'Oman',
  'Bahrain',
  'Lebanon',
  'Kazakhstan',
  'North Africa'
];

// Combine all integrations
export const allIntegrations = [
  ...erpIntegrations,
  ...invoiceIntegrations, 
  ...crmIntegrations,
  ...mediaChannelIntegrations,
  ...additionalIntegrations,
  ...apiConnectors
];